export interface IconsProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const FavouriteFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
      fill="white"
    />
  </svg>
);

export const FavouriteOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.73 3.51063L15.49 7.03063C15.73 7.52063 16.37 7.99063 16.91 8.08063L20.1 8.61062C22.14 8.95062 22.62 10.4306 21.15 11.8906L18.67 14.3706C18.25 14.7906 18.02 15.6006 18.15 16.1806L18.86 19.2506C19.42 21.6806 18.13 22.6206 15.98 21.3506L12.99 19.5806C12.45 19.2606 11.56 19.2606 11.01 19.5806L8.02003 21.3506C5.88003 22.6206 4.58003 21.6706 5.14003 19.2506L5.85003 16.1806C5.98003 15.6006 5.75003 14.7906 5.33003 14.3706L2.85003 11.8906C1.39003 10.4306 1.86003 8.95062 3.90003 8.61062L7.09003 8.08063C7.62003 7.99063 8.26003 7.52063 8.50003 7.03063L10.26 3.51063C11.22 1.60063 12.78 1.60063 13.73 3.51063Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CartFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8371 11.2339H17.6064C18.0263 11.2339 18.3562 10.8869 18.3562 10.4685C18.3562 10.0399 18.0263 9.70312 17.6064 9.70312H14.8371C14.4172 9.70312 14.0873 10.0399 14.0873 10.4685C14.0873 10.8869 14.4172 11.2339 14.8371 11.2339ZM20.8963 5.92749C21.5062 5.92749 21.9061 6.1418 22.306 6.61123C22.7058 7.08067 22.7758 7.7542 22.6859 8.36549L21.7361 15.06C21.5561 16.3469 20.4764 17.2949 19.2067 17.2949H8.29957C6.96991 17.2949 5.87019 16.255 5.76022 14.908L4.84046 3.7834L3.33085 3.51807C2.93095 3.44664 2.65102 3.04864 2.72101 2.64043C2.79099 2.22305 3.18089 1.94649 3.59078 2.00874L5.97517 2.3751C6.31508 2.43735 6.56501 2.72207 6.59501 3.06905L6.78496 5.35499C6.81495 5.68257 7.07488 5.92749 7.3948 5.92749H20.8963ZM8.13816 18.9082C7.29838 18.9082 6.61855 19.6021 6.61855 20.4594C6.61855 21.3064 7.29838 22.0003 8.13816 22.0003C8.96795 22.0003 9.64777 21.3064 9.64777 20.4594C9.64777 19.6021 8.96795 18.9082 8.13816 18.9082ZM19.3862 18.9082C18.5464 18.9082 17.8666 19.6021 17.8666 20.4594C17.8666 21.3064 18.5464 22.0003 19.3862 22.0003C20.216 22.0003 20.8958 21.3064 20.8958 20.4594C20.8958 19.6021 20.216 18.9082 19.3862 18.9082Z"
      fill="white"
    />
  </svg>
);

export const UserFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0453 7.29105C18.0453 10.2281 15.6892 12.5831 12.7485 12.5831C9.80891 12.5831 7.45179 10.2281 7.45179 7.29105C7.45179 4.35402 9.80891 2 12.7485 2C15.6892 2 18.0453 4.35402 18.0453 7.29105ZM12.7514 22C8.41154 22 4.74726 21.295 4.74726 18.575C4.74726 15.8539 8.43456 15.1739 12.7514 15.1739C17.0923 15.1739 20.7556 15.8789 20.7556 18.599C20.7556 21.32 17.0683 22 12.7514 22Z"
      fill="white"
    />
  </svg>
);

export const LogoutOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4399 14.62L19.9999 12.06L17.4399 9.5"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.76001 12.0601H19.93"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.76 20C7.34001 20 3.76001 17 3.76001 12C3.76001 7 7.34001 4 11.76 4"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuBarIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "32"}
    height={height || "32"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M5 8H27M5 16H27M5 24H27"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Arrow Icons
export const ArrowUpSquareOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.46997 13.4599L12 9.93994L15.53 13.4599"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowSquareDownOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.46997 10.6399L12 14.1599L15.53 10.6399"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowSquareLeftOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.26 15.53L9.73999 12L13.26 8.46997"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowSquareRightOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.74 15.53L14.26 12L10.74 8.46997"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.90991 19.9201L15.4299 13.4001C16.1999 12.6301 16.1999 11.3701 15.4299 10.6001L8.90991 4.08008"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.0001 19.9201L8.48009 13.4001C7.71009 12.6301 7.71009 11.3701 8.48009 10.6001L15.0001 4.08008"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Other Icons
export const StartOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.73 3.50989L15.49 7.02989C15.73 7.51989 16.37 7.98989 16.91 8.07989L20.1 8.60989C22.14 8.94989 22.62 10.4299 21.15 11.8899L18.67 14.3699C18.25 14.7899 18.02 15.5999 18.15 16.1799L18.86 19.2499C19.42 21.6799 18.13 22.6199 15.98 21.3499L12.99 19.5799C12.45 19.2599 11.56 19.2599 11.01 19.5799L8.02003 21.3499C5.88003 22.6199 4.58003 21.6699 5.14003 19.2499L5.85003 16.1799C5.98003 15.5999 5.75003 14.7899 5.33003 14.3699L2.85003 11.8899C1.39003 10.4299 1.86003 8.94989 3.90003 8.60989L7.09003 8.07989C7.62003 7.98989 8.26003 7.51989 8.50003 7.02989L10.26 3.50989C11.22 1.59989 12.78 1.59989 13.73 3.50989Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    />
    <path
      d="M18.9299 20.6898C19.4599 22.2898 20.6699 22.4498 21.5999 21.0498C22.4499 19.7698 21.8899 18.7198 20.3499 18.7198C19.2099 18.7098 18.5699 19.5998 18.9299 20.6898Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    />
  </svg>
);

export const InfoOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "18"}
    height={height || "18"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9.75 14.25H11.25V9.75H9.75V14.25ZM10.5 8.25C10.7125 8.25 10.8907 8.178 11.0347 8.034C11.1782 7.8905 11.25 7.7125 11.25 7.5C11.25 7.2875 11.1782 7.10925 11.0347 6.96525C10.8907 6.82175 10.7125 6.75 10.5 6.75C10.2875 6.75 10.1095 6.82175 9.966 6.96525C9.822 7.10925 9.75 7.2875 9.75 7.5C9.75 7.7125 9.822 7.8905 9.966 8.034C10.1095 8.178 10.2875 8.25 10.5 8.25ZM10.5 18C9.4625 18 8.4875 17.803 7.575 17.409C6.6625 17.0155 5.86875 16.4812 5.19375 15.8062C4.51875 15.1312 3.9845 14.3375 3.591 13.425C3.197 12.5125 3 11.5375 3 10.5C3 9.4625 3.197 8.4875 3.591 7.575C3.9845 6.6625 4.51875 5.86875 5.19375 5.19375C5.86875 4.51875 6.6625 3.98425 7.575 3.59025C8.4875 3.19675 9.4625 3 10.5 3C11.5375 3 12.5125 3.19675 13.425 3.59025C14.3375 3.98425 15.1312 4.51875 15.8062 5.19375C16.4812 5.86875 17.0155 6.6625 17.409 7.575C17.803 8.4875 18 9.4625 18 10.5C18 11.5375 17.803 12.5125 17.409 13.425C17.0155 14.3375 16.4812 15.1312 15.8062 15.8062C15.1312 16.4812 14.3375 17.0155 13.425 17.409C12.5125 17.803 11.5375 18 10.5 18ZM10.5 16.5C12.175 16.5 13.5937 15.9187 14.7562 14.7562C15.9187 13.5937 16.5 12.175 16.5 10.5C16.5 8.825 15.9187 7.40625 14.7562 6.24375C13.5937 5.08125 12.175 4.5 10.5 4.5C8.825 4.5 7.40625 5.08125 6.24375 6.24375C5.08125 7.40625 4.5 8.825 4.5 10.5C4.5 12.175 5.08125 13.5937 6.24375 14.7562C7.40625 15.9187 8.825 16.5 10.5 16.5Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const CheckCheckedIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.67 2H16.34C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2ZM11.43 14.99L16.18 10.24C16.52 9.9 16.52 9.35 16.18 9C15.84 8.66 15.28 8.66 14.94 9L10.81 13.13L9.06 11.38C8.72 11.04 8.16 11.04 7.82 11.38C7.48 11.72 7.48 12.27 7.82 12.62L10.2 14.99C10.37 15.16 10.59 15.24 10.81 15.24C11.04 15.24 11.26 15.16 11.43 14.99Z"
      fill="#0D0D0D"
    />
  </svg>
);

export const CheckUncheckedIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3345 2.75H7.66549C4.64449 2.75 2.75049 4.889 2.75049 7.916V16.084C2.75049 19.111 4.63549 21.25 7.66549 21.25H16.3335C19.3645 21.25 21.2505 19.111 21.2505 16.084V7.916C21.2505 4.889 19.3645 2.75 16.3345 2.75Z"
      stroke="#495057"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Money icons
export const DiscountOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15L15 9"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4945 14.5H14.5035"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49451 9.5H9.50349"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RewardPointOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 9C19 10.45 18.57 11.78 17.83 12.89C16.75 14.49 15.04 15.62 13.05 15.91C12.71 15.97 12.36 16 12 16C11.64 16 11.29 15.97 10.95 15.91C8.96 15.62 7.25 14.49 6.17 12.89C5.43 11.78 5 10.45 5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2501 18.4704L19.6001 18.8604C19.2301 18.9504 18.9401 19.2304 18.8601 19.6004L18.5101 21.0704C18.3201 21.8704 17.3001 22.1104 16.7701 21.4804L12.0001 16.0004L7.23008 21.4904C6.70008 22.1204 5.68008 21.8804 5.49008 21.0804L5.14008 19.6104C5.05008 19.2404 4.76008 18.9504 4.40008 18.8704L2.75008 18.4804C1.99008 18.3004 1.72008 17.3504 2.27008 16.8004L6.17008 12.9004C7.25008 14.5004 8.96008 15.6304 10.9501 15.9204C11.2901 15.9804 11.6401 16.0104 12.0001 16.0104C12.3601 16.0104 12.7101 15.9804 13.0501 15.9204C15.0401 15.6304 16.7501 14.5004 17.8301 12.9004L21.7301 16.8004C22.2801 17.3404 22.0101 18.2904 21.2501 18.4704Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.58 5.98L13.17 7.15999C13.25 7.31999 13.46 7.48 13.65 7.51L14.72 7.68999C15.4 7.79999 15.56 8.3 15.07 8.79L14.24 9.61998C14.1 9.75998 14.02 10.03 14.07 10.23L14.31 11.26C14.5 12.07 14.07 12.39 13.35 11.96L12.35 11.37C12.17 11.26 11.87 11.26 11.69 11.37L10.69 11.96C9.96997 12.38 9.53997 12.07 9.72997 11.26L9.96997 10.23C10.01 10.04 9.93997 9.75998 9.79997 9.61998L8.96997 8.79C8.47997 8.3 8.63997 7.80999 9.31997 7.68999L10.39 7.51C10.57 7.48 10.78 7.31999 10.86 7.15999L11.45 5.98C11.74 5.34 12.26 5.34 12.58 5.98Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OfferOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15L15 9"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4945 14.5H14.5035"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49451 9.5H9.50349"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Essetional icons
export const TrashOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.85 9.13989L18.2 19.2099C18.09 20.7799 18 21.9999 15.21 21.9999H8.79002C6.00002 21.9999 5.91002 20.7799 5.80002 19.2099L5.15002 9.13989"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.33 16.5H13.66"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 12.5H14.5"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 12H18"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18V6"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MinusOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 12H18"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckRoundOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckRoundFillIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M13.9997 2.3335C7.57134 2.3335 2.33301 7.57183 2.33301 14.0002C2.33301 20.4285 7.57134 25.6668 13.9997 25.6668C20.428 25.6668 25.6663 20.4285 25.6663 14.0002C25.6663 7.57183 20.428 2.3335 13.9997 2.3335ZM19.5763 11.3168L12.9613 17.9318C12.798 18.0952 12.5763 18.1885 12.343 18.1885C12.1097 18.1885 11.888 18.0952 11.7247 17.9318L8.42301 14.6302C8.08467 14.2918 8.08467 13.7318 8.42301 13.3935C8.76134 13.0552 9.32134 13.0552 9.65967 13.3935L12.343 16.0768L18.3397 10.0802C18.678 9.74183 19.238 9.74183 19.5763 10.0802C19.9147 10.4185 19.9147 10.9668 19.5763 11.3168Z" />
  </svg>
);

export const ManageAddressOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 13H12"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17H16"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThreeDotOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "5"}
    height={height || "25"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5 25"
    fill="none"
  >
    <circle cx="2.36364" cy="2.36364" r="2.36364" fill="#7A7A83" />
    <circle cx="2.36364" cy="12.0902" r="2.36364" fill="#7A7A83" />
    <circle cx="2.36364" cy="21.8168" r="2.36364" fill="#7A7A83" />
  </svg>
);

export const PaymentMethodOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 8.50586H22"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 16.5059H8"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 16.5059H14.5"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.44 3.50586H17.55C21.11 3.50586 22 4.38586 22 7.89586V16.1059C22 19.6159 21.11 20.4959 17.56 20.4959H6.44C2.89 20.5059 2 19.6259 2 16.1159V7.89586C2 4.38586 2.89 3.50586 6.44 3.50586Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FAQChatdOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 18.4297H13L8.54999 21.3897C7.88999 21.8297 7 21.3598 7 20.5598V18.4297C4 18.4297 2 16.4297 2 13.4297V7.42969C2 4.42969 4 2.42969 7 2.42969H17C20 2.42969 22 4.42969 22 7.42969V13.4297C22 16.4297 20 18.4297 17 18.4297Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0001 11.3594V11.1494C12.0001 10.4694 12.4201 10.1094 12.8401 9.8194C13.2501 9.5394 13.66 9.17941 13.66 8.51941C13.66 7.59941 12.9201 6.85938 12.0001 6.85938C11.0801 6.85938 10.3401 7.59941 10.3401 8.51941"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 13.75H12.0045"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** User icons
export const UserOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Orders icons
export const OrderListOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.37 8.88086H17.62"
      stroke="#36454F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.38 8.88086L7.13 9.63086L9.38 7.38086"
      stroke="#36454F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.37 15.8809H17.62"
      stroke="#36454F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.38 15.8809L7.13 16.6309L9.38 14.3809"
      stroke="#36454F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#36454F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Content, Edit icons
export const EditPenOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.26 3.60022L5.04997 12.2902C4.73997 12.6202 4.43997 13.2702 4.37997 13.7202L4.00997 16.9602C3.87997 18.1302 4.71997 18.9302 5.87997 18.7302L9.09997 18.1802C9.54997 18.1002 10.18 17.7702 10.49 17.4302L18.7 8.74022C20.12 7.24022 20.76 5.53022 18.55 3.44022C16.35 1.37022 14.68 2.10022 13.26 3.60022Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.89 5.0498C12.32 7.8098 14.56 9.9198 17.34 10.1998"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 22H21"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 4.5H21"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9.5H12.47"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 14.5H21"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 19.5H12.47"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.40002 2.1001H18.6C19.7 2.1001 20.6 3.0001 20.6 4.1001V6.3001C20.6 7.1001 20.1 8.1001 19.6 8.6001L15.3 12.4001C14.7 12.9001 14.3 13.9001 14.3 14.7001V19.0001C14.3 19.6001 13.9 20.4001 13.4 20.7001L12 21.6001C10.7 22.4001 8.90002 21.5001 8.90002 19.9001V14.6001C8.90002 13.9001 8.50002 13.0001 8.10002 12.5001L4.30002 8.5001C3.80002 8.0001 3.40002 7.1001 3.40002 6.5001V4.2001C3.40002 3.0001 4.30002 2.1001 5.40002 2.1001Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.93 2.1001L6 10.0001"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** input icons
export const PasswordOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NameProfileOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OtpCodeOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9965 16H16.0054"
      stroke="#7A7A83"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 16H12.0045"
      stroke="#7A7A83"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99451 16H8.00349"
      stroke="#7A7A83"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** Social icons
export const FacebookFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M22.0229 12C22.0229 6.48 17.5383 2 12.0125 2C6.48676 2 2.00209 6.48 2.00209 12C2.00209 16.84 5.44568 20.87 10.0104 21.8V15H8.00835V12H10.0104V9.5C10.0104 7.57 11.5821 6 13.5141 6H16.0167V9H14.0146C13.464 9 13.0136 9.45 13.0136 10V12H16.0167V15H13.0136V21.95C18.0688 21.45 22.0229 17.19 22.0229 12Z"
      fill="white"
    />
  </svg>
);

export const YoutubeFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M10.0605 15L15.2559 12L10.0605 9V15ZM21.6326 7.17C21.7627 7.64 21.8528 8.27 21.9129 9.07C21.9829 9.87 22.013 10.56 22.013 11.16L22.073 12C22.073 14.19 21.9129 15.8 21.6326 16.83C21.3823 17.73 20.8017 18.31 19.9008 18.56C19.4303 18.69 18.5694 18.78 17.248 18.84C15.9466 18.91 14.7554 18.94 13.6543 18.94L12.0626 19C7.86823 19 5.25551 18.84 4.22443 18.56C3.32349 18.31 2.74289 17.73 2.49263 16.83C2.36249 16.36 2.2724 15.73 2.21234 14.93C2.14226 14.13 2.11223 13.44 2.11223 12.84L2.05217 12C2.05217 9.81 2.21234 8.2 2.49263 7.17C2.74289 6.27 3.32349 5.69 4.22443 5.44C4.69492 5.31 5.55582 5.22 6.8772 5.16C8.17855 5.09 9.36979 5.06 10.4709 5.06L12.0626 5C16.257 5 18.8697 5.16 19.9008 5.44C20.8017 5.69 21.3823 6.27 21.6326 7.17Z"
      fill="white"
    />
  </svg>
);

export const TwiterFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M23.155 7.28105L20.3489 10.0842C19.7821 16.6485 14.2404 21.7504 7.60813 21.7504C6.24546 21.7504 5.12211 21.5348 4.26903 21.1092C3.58113 20.7651 3.29958 20.3967 3.2292 20.2917C3.16644 20.1977 3.12576 20.0907 3.1102 19.9787C3.09464 19.8668 3.1046 19.7528 3.13935 19.6453C3.17409 19.5377 3.23272 19.4394 3.31084 19.3577C3.38897 19.2759 3.48457 19.2129 3.59051 19.1732C3.61491 19.1639 5.86538 18.3004 7.29468 16.657C6.50203 16.006 5.81008 15.2414 5.24129 14.3882C4.07758 12.6623 2.77497 9.66417 3.17664 5.18386C3.18937 5.0415 3.24256 4.90573 3.32995 4.79256C3.41733 4.67938 3.53526 4.5935 3.66987 4.54503C3.80447 4.49657 3.95013 4.48753 4.0897 4.51899C4.22927 4.55045 4.35694 4.6211 4.45766 4.72261C4.49051 4.75542 7.58092 7.82574 11.3592 8.82136V8.25042C11.3578 7.65173 11.4763 7.0588 11.7077 6.50655C11.9392 5.9543 12.2789 5.4539 12.7069 5.0348C13.1225 4.62017 13.6171 4.2929 14.1614 4.07231C14.7057 3.85172 15.2888 3.74227 15.8761 3.75042C16.664 3.75819 17.4365 3.96947 18.1185 4.36374C18.8005 4.75801 19.3687 5.32184 19.768 6.00042H22.6238C22.7723 6.00031 22.9176 6.04423 23.0412 6.12663C23.1648 6.20904 23.2611 6.32621 23.318 6.46333C23.3748 6.60045 23.3897 6.75134 23.3607 6.8969C23.3317 7.04247 23.2601 7.17616 23.155 7.28105Z"
      fill="white"
    />
  </svg>
);

export const InstagramFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M13.1918 2.00123C13.9223 1.99843 14.6528 2.00576 15.383 2.02323L15.5772 2.03023C15.8015 2.03823 16.0227 2.04823 16.29 2.06023C17.3551 2.11023 18.0819 2.27823 18.7195 2.52523C19.3802 2.77923 19.9368 3.12323 20.4934 3.67923C21.0023 4.17884 21.3961 4.78318 21.6476 5.45023C21.8948 6.08723 22.063 6.81423 22.1131 7.87823C22.1251 8.14423 22.1351 8.36623 22.1431 8.59023L22.1491 8.78423C22.1669 9.51342 22.1746 10.2428 22.1721 10.9722L22.1731 11.7182V13.0282C22.1756 13.758 22.1679 14.4877 22.1501 15.2172L22.1441 15.4112C22.1361 15.6352 22.1261 15.8562 22.1141 16.1232C22.064 17.1872 21.8938 17.9132 21.6476 18.5502C21.397 19.218 21.003 19.8228 20.4934 20.3222C19.9928 20.8306 19.3875 21.224 18.7195 21.4752C18.0819 21.7222 17.3551 21.8902 16.29 21.9402C16.0227 21.9522 15.8015 21.9622 15.5772 21.9702L15.383 21.9762C14.6528 21.994 13.9223 22.0017 13.1918 21.9992L12.445 22.0002H11.1346C10.4041 22.0027 9.67362 21.995 8.94334 21.9772L8.74913 21.9712C8.5115 21.9626 8.27391 21.9526 8.03639 21.9412C6.97128 21.8912 6.24452 21.7212 5.60586 21.4752C4.93785 21.2246 4.33277 20.8311 3.83301 20.3222C3.32353 19.8225 2.9293 19.2178 2.67781 18.5502C2.43055 17.9132 2.26238 17.1872 2.21232 16.1232C2.20118 15.8859 2.19116 15.6486 2.18229 15.4112L2.17729 15.2172C2.15883 14.4877 2.15049 13.758 2.15226 13.0282V10.9722C2.14947 10.2428 2.15681 9.51343 2.17428 8.78423L2.18129 8.59023C2.1893 8.36623 2.19931 8.14423 2.21132 7.87823C2.26138 6.81323 2.42955 6.08823 2.67681 5.45023C2.92844 4.78285 3.32345 4.17868 3.83401 3.68023C4.33343 3.17098 4.93812 2.7768 5.60586 2.52523C6.24452 2.27823 6.97028 2.11023 8.03639 2.06023L8.74913 2.03023L8.94334 2.02523C9.67328 2.0068 10.4034 1.99847 11.1336 2.00023L13.1918 2.00123ZM12.1627 7.00123C11.4995 6.99186 10.8411 7.11425 10.2256 7.3613C9.61023 7.60834 9.05009 7.97511 8.5778 8.44029C8.10551 8.90546 7.73047 9.45977 7.47449 10.071C7.21851 10.6822 7.08669 11.3382 7.08669 12.0007C7.08669 12.6633 7.21851 13.3192 7.47449 13.9305C7.73047 14.5417 8.10551 15.096 8.5778 15.5612C9.05009 16.0264 9.61023 16.3931 10.2256 16.6402C10.8411 16.8872 11.4995 17.0096 12.1627 17.0002C13.4902 17.0002 14.7632 16.4734 15.7019 15.5358C16.6406 14.5981 17.1679 13.3263 17.1679 12.0002C17.1679 10.6741 16.6406 9.40238 15.7019 8.4647C14.7632 7.52701 13.4902 7.00123 12.1627 7.00123ZM12.1627 9.00123C12.5616 8.99389 12.958 9.06603 13.3287 9.21344C13.6994 9.36085 14.037 9.58057 14.3217 9.85978C14.6065 10.139 14.8326 10.4721 14.9871 10.8396C15.1415 11.2071 15.2211 11.6016 15.2211 12.0002C15.2212 12.3988 15.1418 12.7934 14.9875 13.1609C14.8332 13.5285 14.6071 13.8617 14.3224 14.141C14.0378 14.4203 13.7003 14.6401 13.3296 14.7876C12.959 14.9352 12.5626 15.0074 12.1637 15.0002C11.3672 15.0002 10.6034 14.6842 10.0402 14.1216C9.47696 13.5589 9.16056 12.7959 9.16056 12.0002C9.16056 11.2046 9.47696 10.4415 10.0402 9.87891C10.6034 9.3163 11.3672 9.00023 12.1637 9.00023L12.1627 9.00123ZM17.4182 5.50123C17.0952 5.51414 16.7898 5.65138 16.5659 5.8842C16.342 6.11702 16.2169 6.42736 16.2169 6.75023C16.2169 7.0731 16.342 7.38344 16.5659 7.61626C16.7898 7.84908 17.0952 7.98632 17.4182 7.99923C17.75 7.99923 18.0683 7.86753 18.303 7.63311C18.5376 7.39869 18.6695 7.08075 18.6695 6.74923C18.6695 6.41771 18.5376 6.09977 18.303 5.86535C18.0683 5.63093 17.75 5.49923 17.4182 5.49923V5.50123Z"
      fill="white"
    />
  </svg>
);

export const LinkedInFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M18.5554 18.339H15.8876V14.162C15.8876 13.166 15.8676 11.884 14.4961 11.884C13.1057 11.884 12.8935 12.968 12.8935 14.089V18.339H10.2247V9.75H12.7874V10.92H12.8224C13.1808 10.246 14.0517 9.533 15.353 9.533C18.0559 9.533 18.5564 11.311 18.5564 13.624L18.5554 18.339ZM7.21156 8.575C7.0079 8.57526 6.8062 8.53537 6.618 8.45761C6.42981 8.37984 6.25884 8.26574 6.11487 8.12184C5.97091 7.97793 5.8568 7.80706 5.77908 7.61901C5.70135 7.43097 5.66155 7.22944 5.66195 7.026C5.66214 6.71983 5.75322 6.4206 5.92366 6.16615C6.0941 5.91169 6.33624 5.71343 6.61947 5.59645C6.9027 5.47947 7.2143 5.44902 7.51486 5.50894C7.81541 5.56886 8.09143 5.71648 8.30801 5.93311C8.52459 6.14974 8.672 6.42566 8.73159 6.72598C8.79119 7.0263 8.7603 7.33753 8.64283 7.62032C8.52536 7.9031 8.32659 8.14474 8.07165 8.31467C7.8167 8.4846 7.51704 8.5752 7.21056 8.575H7.21156ZM8.54895 18.339H5.87317V9.75H8.54895V18.339ZM19.8908 3H4.53477C3.798 3 3.20338 3.58 3.20338 4.297V19.703C3.20338 20.42 3.798 21 4.53277 21H19.8878C20.6215 21 21.2222 20.42 21.2222 19.703V4.297C21.2222 3.581 20.6215 3 19.8868 3H19.8908Z"
      fill="white"
    />
  </svg>
);

export const PhoneFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "21"}
    height={height || "20"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    fill={"none"}
  >
    <path
      d="M16.6443 17.5C16.8946 17.5 17.1031 17.4167 17.2699 17.25C17.4368 17.0833 17.5202 16.875 17.5202 16.625V13.25C17.5202 13.0556 17.4576 12.8853 17.3325 12.7392C17.2074 12.5931 17.0475 12.4994 16.8528 12.4583L13.9748 11.875C13.7802 11.8472 13.5819 11.8647 13.3801 11.9275C13.1782 11.9903 13.015 12.0839 12.8904 12.2083L10.93 14.1667C9.87335 13.5278 8.90706 12.7708 8.03115 11.8958C7.15524 11.0208 6.42531 10.0833 5.84137 9.08333L7.84346 7.04167C7.96859 6.91667 8.04867 6.77417 8.08371 6.61417C8.11874 6.45417 8.12208 6.27722 8.09372 6.08333L7.55149 3.16667C7.52368 2.97222 7.43331 2.8125 7.28037 2.6875C7.12743 2.5625 6.95364 2.5 6.75899 2.5H3.38047C3.13021 2.5 2.92166 2.58333 2.75482 2.75C2.58798 2.91667 2.50456 3.125 2.50456 3.375C2.50456 5.16667 2.90442 6.91333 3.70415 8.615C4.50387 10.3167 5.56052 11.8236 6.87411 13.1358C8.1877 14.4481 9.69622 15.5036 11.3997 16.3025C13.1031 17.1014 14.8513 17.5006 16.6443 17.5Z"
      fill="white"
      className={className}
    />
  </svg>
);

export const WhatsappOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.001 2C17.524 2 22.001 6.477 22.001 12C22.001 17.523 17.524 22 12.001 22C10.2338 22.0029 8.49765 21.5352 6.97099 20.645L2.00499 22L3.35699 17.032C2.46608 15.5049 1.99804 13.768 2.00099 12C2.00099 6.477 6.47799 2 12.001 2ZM8.59299 7.3L8.39299 7.308C8.26351 7.31589 8.13697 7.3499 8.02099 7.408C7.91251 7.46943 7.81349 7.54622 7.72699 7.636C7.60699 7.749 7.53899 7.847 7.46599 7.942C7.09611 8.4229 6.89696 9.01331 6.89999 9.62C6.90199 10.11 7.02999 10.587 7.22999 11.033C7.63899 11.935 8.31199 12.89 9.19999 13.775C9.41399 13.988 9.62399 14.202 9.84999 14.401C10.9534 15.3725 12.2682 16.073 13.69 16.447L14.258 16.534C14.443 16.544 14.628 16.53 14.814 16.521C15.1052 16.506 15.3896 16.4271 15.647 16.29C15.7779 16.2225 15.9057 16.1491 16.03 16.07C16.03 16.07 16.073 16.042 16.155 15.98C16.29 15.88 16.373 15.809 16.485 15.692C16.568 15.606 16.64 15.505 16.695 15.39C16.773 15.227 16.851 14.916 16.883 14.657C16.907 14.459 16.9 14.351 16.897 14.284C16.893 14.177 16.804 14.066 16.707 14.019L16.125 13.758C16.125 13.758 15.255 13.379 14.723 13.137C14.6673 13.1127 14.6077 13.0988 14.547 13.096C14.4786 13.089 14.4094 13.0967 14.3442 13.1186C14.279 13.1405 14.2193 13.1761 14.169 13.223C14.164 13.221 14.097 13.278 13.374 14.154C13.3325 14.2098 13.2753 14.2519 13.2098 14.2751C13.1443 14.2982 13.0733 14.3013 13.006 14.284C12.9408 14.2665 12.877 14.2445 12.815 14.218C12.691 14.166 12.648 14.146 12.563 14.11C11.9891 13.8595 11.4577 13.5211 10.988 13.107C10.862 12.997 10.745 12.877 10.625 12.761C10.2316 12.3842 9.88871 11.958 9.60499 11.493L9.54599 11.398C9.50361 11.3342 9.46935 11.2653 9.44399 11.193C9.40599 11.046 9.50499 10.928 9.50499 10.928C9.50499 10.928 9.74799 10.662 9.86099 10.518C9.97099 10.378 10.064 10.242 10.124 10.145C10.242 9.955 10.279 9.76 10.217 9.609C9.93699 8.925 9.64699 8.244 9.34899 7.568C9.28999 7.434 9.11499 7.338 8.95599 7.319C8.90199 7.313 8.84799 7.307 8.79399 7.303C8.6597 7.29633 8.52512 7.29766 8.39099 7.307L8.59299 7.3Z"
      fill="black"
    />
  </svg>
);

export const PhoneOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export const MessageFillIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "21"}
    height={height || "20"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M16.8348 3.33301H3.48752C2.5699 3.33301 1.82746 4.08301 1.82746 4.99967L1.81912 14.9997C1.81912 15.9163 2.5699 16.6663 3.48752 16.6663H16.8348C17.7524 16.6663 18.5032 15.9163 18.5032 14.9997V4.99967C18.5032 4.08301 17.7524 3.33301 16.8348 3.33301ZM16.5011 6.87467L10.6033 10.558C10.3363 10.7247 9.98596 10.7247 9.71902 10.558L3.82121 6.87467C3.73756 6.82777 3.66431 6.76439 3.60589 6.68839C3.54747 6.61238 3.5051 6.52532 3.48133 6.43248C3.45757 6.33964 3.45291 6.24295 3.46763 6.14826C3.48236 6.05357 3.51617 5.96285 3.56701 5.88159C3.61785 5.80033 3.68467 5.73022 3.76342 5.6755C3.84217 5.62079 3.93121 5.5826 4.02516 5.56326C4.11912 5.54391 4.21602 5.54381 4.31001 5.56296C4.404 5.58212 4.49313 5.62012 4.57199 5.67467L10.1611 9.16634L15.7503 5.67467C15.8292 5.62012 15.9183 5.58212 16.0123 5.56296C16.1063 5.54381 16.2032 5.54391 16.2971 5.56326C16.3911 5.5826 16.4801 5.62079 16.5589 5.6755C16.6376 5.73022 16.7044 5.80033 16.7553 5.88159C16.8061 5.96285 16.8399 6.05357 16.8546 6.14826C16.8694 6.24295 16.8647 6.33964 16.841 6.43248C16.8172 6.52532 16.7748 6.61238 16.7164 6.68839C16.658 6.76439 16.5847 6.82777 16.5011 6.87467Z"
      fill="white"
    />
  </svg>
);

export const ShareOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.59 12L15 7.41V9.87L14.14 10C9.83 10.61 6.91 12.87 5.24 16.33C7.56 14.69 10.44 13.9 14 13.9H15V16.59M13 14.92C8.53 15.13 5.33 16.74 3 20C4 15 7 10 14 9V5L21 12L14 19V14.9C13.67 14.9 13.34 14.91 13 14.92Z"
      fill="black"
    />
  </svg>
);

export const CopyOutlineIcon = ({ className, width, height }: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ** location
export const GPSLocationOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 4V2"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H2"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 20V22"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 12H22"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const LocationOutlineIcon = ({
// 	className,
// 	width,
// 	height,
// }: IconsProps) => (
// 	<svg
// 		className={className}
// 		width={width || "28"}
// 		height={height || "28"}
// 		xmlns="http://www.w3.org/2000/svg"
// 		viewBox="0 0 28 28"
// 		fill="none">
// 		<path
// 			d="M14 2.25C16.5859 2.25 19.0658 3.27723 20.8943 5.10571C22.7228 6.93419 23.75 9.41414 23.75 12C23.75 16.12 20.855 20.61 15.14 25.518C14.8222 25.791 14.4171 25.9409 13.9981 25.9405C13.5792 25.9402 13.1743 25.7895 12.857 25.516L12.479 25.188C7.017 20.408 4.25 16.028 4.25 12C4.25 9.41414 5.27723 6.93419 7.10571 5.10571C8.93419 3.27723 11.4141 2.25 14 2.25ZM14 3.75C11.812 3.75 9.71354 4.61919 8.16637 6.16637C6.61919 7.71354 5.75 9.81196 5.75 12C5.75 15.502 8.298 19.537 13.464 24.057L13.837 24.38C13.8824 24.419 13.9402 24.4404 14 24.4404C14.0598 24.4404 14.1176 24.419 14.163 24.38C19.579 19.728 22.25 15.585 22.25 12C22.25 10.9166 22.0366 9.8438 21.622 8.84286C21.2074 7.84193 20.5997 6.93245 19.8336 6.16637C19.0675 5.40029 18.1581 4.7926 17.1571 4.37799C16.1562 3.96339 15.0834 3.75 14 3.75ZM14 8.25C14.9946 8.25 15.9484 8.64509 16.6517 9.34835C17.3549 10.0516 17.75 11.0054 17.75 12C17.75 12.9946 17.3549 13.9484 16.6517 14.6517C15.9484 15.3549 14.9946 15.75 14 15.75C13.0054 15.75 12.0516 15.3549 11.3483 14.6517C10.6451 13.9484 10.25 12.9946 10.25 12C10.25 11.0054 10.6451 10.0516 11.3483 9.34835C12.0516 8.64509 13.0054 8.25 14 8.25ZM14 9.75C13.4033 9.75 12.831 9.98705 12.409 10.409C11.9871 10.831 11.75 11.4033 11.75 12C11.75 12.5967 11.9871 13.169 12.409 13.591C12.831 14.0129 13.4033 14.25 14 14.25C14.5967 14.25 15.169 14.0129 15.591 13.591C16.0129 13.169 16.25 12.5967 16.25 12C16.25 11.4033 16.0129 10.831 15.591 10.409C15.169 9.98705 14.5967 9.75 14 9.75Z"
// 			fill="black"
// 		/>
// 	</svg>
// );

export const LocationOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "32"}
    height={height || "32"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 2C13.0837 2.00344 10.2878 3.16347 8.22564 5.22563C6.16348 7.28778 5.00345 10.0837 5.00001 13C4.99652 15.3832 5.77499 17.7018 7.21601 19.6C7.21601 19.6 7.51601 19.995 7.56501 20.052L16 30L24.439 20.047C24.483 19.994 24.784 19.6 24.784 19.6L24.785 19.597C26.2253 17.6996 27.0034 15.3821 27 13C26.9966 10.0837 25.8365 7.28778 23.7744 5.22563C21.7122 3.16347 18.9163 2.00344 16 2ZM16 17C15.2089 17 14.4355 16.7654 13.7777 16.3259C13.1199 15.8864 12.6072 15.2616 12.3045 14.5307C12.0017 13.7998 11.9225 12.9956 12.0769 12.2196C12.2312 11.4437 12.6122 10.731 13.1716 10.1716C13.731 9.61216 14.4437 9.2312 15.2197 9.07686C15.9956 8.92252 16.7998 9.00173 17.5307 9.30448C18.2616 9.60723 18.8864 10.1199 19.3259 10.7777C19.7654 11.4355 20 12.2089 20 13C19.9987 14.0605 19.5768 15.0771 18.827 15.827C18.0771 16.5768 17.0605 16.9987 16 17Z"
      fill="white"
    />
  </svg>
);

export const DirectionOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width || "24"}
    height={height || "24"}
    viewBox="0 -960 960 960"
  >
    <path d="M360-120v-567l-64 63-56-56 160-160 160 160-56 57-64-64v261q35-31 79-44.5t88-13.5q11 0 21 1t19 3l-63-64 56-56 160 160-160 160-56-56 63-64q-11-2-22-3.5t-22-1.5q-54 0-99.5 30.5T440-280v160h-80Z" />
  </svg>
);

export const PlayButtonOutline = ({ className, width, height }: IconsProps) => (
  <svg
    fill="#F26E21"
    height={height || "30px"}
    width={width || "30px"}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    className={className}
  >
    <g>
      <path
        d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30
	   c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15
	   C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"
      />
      <path
        d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
	   S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
      />
    </g>
  </svg>
);

export const PlayButtonFill = ({ className, width, height }: IconsProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 24 24"
    fill="#F26E21"
  >
    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l10 6-10 6z" />
  </svg>
);

// ** notification
export const NotificationOutlineIcon = ({
  className,
  width,
  height,
}: IconsProps) => (
  <svg
    className={className}
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.02 2.91016C8.71 2.91016 6.02 5.60016 6.02 8.91016V11.8002C6.02 12.4102 5.76 13.3402 5.45 13.8602L4.3 15.7702C3.59 16.9502 4.08 18.2602 5.38 18.7002C9.69 20.1402 14.34 20.1402 18.65 18.7002C19.86 18.3002 20.39 16.8702 19.73 15.7702L18.58 13.8602C18.28 13.3402 18.02 12.4102 18.02 11.8002V8.91016C18.02 5.61016 15.32 2.91016 12.02 2.91016Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.89999 21.1801C9.35999 20.6401 9.01999 19.8801 9.01999 19.0601"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export const QuestionIcon = ({ className, width, height }: IconsProps) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width || "24px"}
    height={height || "24px"}
    viewBox="0 0 64 64"
    enableBackground="new 0 0 64 64"
    xmlSpace="preserve"
    className={className}
  >
    <path
      fill="none"
      stroke="#000000"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838 c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"
    />
    <line
      stroke="#000000"
      strokeWidth={2}
      strokeMiterlimit={10}
      x1={30}
      y1={43}
      x2={30}
      y2={47}
    />
    <path
      fill="none"
      stroke="#000000"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M24,21c0-3,2-5,8-5c5,0,8,3,8,7s-6,7-6,7s-4,2-4,8v1 "
    />
  </svg>
);

export const ReviewIcon = ({ className, width, height }: IconsProps) => (
  <svg
    fill="#000000"
    width={width || "24px"}
    height={height || "24px"}
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={className}
  >
    <g id="_x32_5_attachment" />
    <g id="_x32_4_office" />
    <g id="_x32_3_pin" />
    <g id="_x32_2_business_card" />
    <g id="_x32_1_form" />
    <g id="_x32_0_headset" />
    <g id="_x31_9_video_call" />
    <g id="_x31_8_letter_box" />
    <g id="_x31_7_papperplane" />
    <g id="_x31_6_laptop" />
    <g id="_x31_5_connection" />
    <g id="_x31_4_phonebook" />
    <g id="_x31_3_classic_telephone" />
    <g id="_x31_2_sending_mail" />
    <g id="_x31_1_man_talking" />
    <g id="_x31_0_date" />
    <g id="_x30_9_review">
      <g>
        <g>
          <path d="M26.2143,38.0547c2.8729,2.5325,5.217,4.2974,9.1597,4.2974h13.2256c1.7871,0,3.2324-0.813,4.0703-2.2891     c0.7842-1.3818,0.8818-3.2026,0.2529-4.4038c0.4404-0.2007,0.8389-0.5156,1.1787-0.938c1.2217-1.52,1.4258-4.1294,0.8496-5.6133     c-0.1113-0.2866-0.2432-0.519-0.3857-0.7085c0.2344-0.1924,0.4668-0.4541,0.6807-0.8081     c1.0947-1.8066,1.1729-5.1699,0.1602-6.9204c-0.1563-0.2705-0.3369-0.5044-0.5371-0.6997     c0.5801-0.6636,0.9336-1.6987,0.9336-2.9253c0.001-2.2627-1.3232-4.6987-4.2334-4.7017L40.7607,12.333     c2.2188-3.2368,2.0586-7.7773,0.6943-9.9741c-0.8184-1.3169-1.9043-1.521-2.749-1.2539c-0.9551,0.0234-1.8115,1.0493-3.126,2.626     c-0.4766,0.5708-0.9863,1.1831-1.5107,1.7441c-4.5332,4.8521-6.0146,6.4463-6.5254,7.019l-1.3748,0.5838     c-0.5378-1.2764-1.8011-2.1751-3.2707-2.1751H14.626c-1.9541,0-3.5439,1.5918-3.5439,3.5479v22.3765     c0,1.9561,1.5898,3.5474,3.5439,3.5474h8.2725C24.4213,40.3745,25.7123,39.405,26.2143,38.0547z M26.4463,15.1328l2.0762-0.8818     c0.1543-0.0654,0.2881-0.1675,0.3906-0.2964c0.251-0.2856,2.9521-3.1909,6.6172-7.1143c0.5566-0.5947,1.0791-1.2222,1.585-1.8286     c0.5879-0.7041,1.3789-1.6528,1.7441-1.8916c0.1445-0.001,0.2881-0.0337,0.4209-0.0967     c0.1611-0.0708,0.3652,0.2124,0.4756,0.3906c1.0918,1.7588,1.2051,6.6836-1.8945,9.1318c-0.334,0.2637-0.4639,0.71-0.3242,1.1123     c0.1387,0.4023,0.5176,0.6719,0.9434,0.6724l13.0869,0.0137c2.1289,0.002,2.2363,2.25,2.2354,2.7007     c0,1.1069-0.4375,1.7153-0.6211,1.7163l-0.1758,0.0068c-0.7783,0.022-1.3535,0.5693-1.3379,1.2739     c0.0137,0.6182,0.5459,1.2578,1.4648,1.2192c0.0938,0.0024,0.3018-0.0049,0.542,0.4111c0.6563,1.1348,0.584,3.6899-0.1387,4.8828     c-0.1426,0.2358-0.2842,0.3574-0.3525,0.3574c0,0-0.001,0-0.002,0c-0.0781-0.002-0.1572,0.0024-0.2354,0.0176     c-0.7178,0.1411-1.207,0.6987-1.1914,1.3564c0.0156,0.6582,0.5254,1.1909,1.1748,1.2739     c0.2998,0.2266,0.5771,1.8604-0.0205,3.2744c-0.5107,1.2036-1.165,1.1035-1.377,1.0679     c-0.0508-0.0078-0.1025-0.0117-0.1533-0.0117l-0.3896,0.0015c-0.5068-0.0273-0.9717,0.1987-1.2256,0.6045     c-0.2334,0.375-0.2471,0.8467-0.0342,1.231c0.2305,0.416,0.6816,0.6646,1.2285,0.6646c0,0,0,0,0.001,0     c0.0078-0.0088,0.0752-0.0049,0.168,0.1523c0.3057,0.5117,0.3174,1.625-0.1963,2.5308     c-0.4814,0.8472-1.2656,1.2764-2.3311,1.2764H35.374c-3.5869,0-5.5234-1.7275-8.7314-4.5894l-0.1963-0.1753V15.1328z      M24.4463,14.4712v21.5645v0.7915c0,0.853-0.6943,1.5474-1.5479,1.5474H14.626c-0.8516,0-1.5439-0.6943-1.5439-1.5474V14.4507     c0-0.8535,0.6924-1.5479,1.5439-1.5479h8.2725c0.8535,0,1.5479,0.6943,1.5479,1.5479V14.4712z" />
          <path d="M17.7305,52.3032l-4.5078-0.8721L11,47.4121c-0.1758-0.3184-0.5107-0.5161-0.875-0.5161     c-0.3633,0-0.6992,0.1978-0.875,0.5156l-2.2236,4.0195l-4.5059,0.8721c-0.3564,0.0693-0.6484,0.3271-0.7607,0.6729     c-0.1123,0.3462-0.0283,0.7261,0.2207,0.9917l3.1338,3.354L4.5498,61.877c-0.0449,0.3613,0.1104,0.7183,0.4043,0.9321     C5.1279,62.9355,5.334,63,5.542,63c0.1436,0,0.2891-0.0313,0.4238-0.0942l4.1592-1.9448l4.1572,1.9448     c0.3291,0.1538,0.7168,0.1187,1.0117-0.0967c0.2939-0.2139,0.4492-0.5708,0.4043-0.9321l-0.5645-4.5552l3.1367-3.3535     c0.248-0.2656,0.333-0.6455,0.2207-0.9917S18.0869,52.3726,17.7305,52.3032z M13.3535,56.2974     c-0.2021,0.2168-0.2988,0.5117-0.2617,0.8062l0.3994,3.2241l-2.9424-1.3765c-0.2695-0.126-0.5781-0.126-0.8477,0l-2.9443,1.377     l0.3994-3.2246c0.0371-0.2939-0.0596-0.5894-0.2617-0.8057l-2.2188-2.3745l3.1895-0.6172c0.29-0.0566,0.541-0.2388,0.6846-0.4976     l1.5752-2.8467l1.5732,2.8462c0.1436,0.2593,0.3945,0.4414,0.6846,0.498l3.1914,0.6172L13.3535,56.2974z" />
          <path d="M39.8984,52.3032l-4.5078-0.8721l-2.2217-4.019c-0.3516-0.6367-1.3984-0.6367-1.75,0l-2.2217,4.019l-4.5078,0.8721     c-0.3574,0.0693-0.6494,0.3271-0.7617,0.6729c-0.1123,0.3462-0.0283,0.7261,0.2207,0.9917l3.1338,3.354l-0.5645,4.5552     c-0.0449,0.3613,0.1104,0.7183,0.4043,0.9321c0.2939,0.2144,0.6826,0.252,1.0117,0.0967l4.1602-1.9448l4.1563,1.9448     C36.585,62.9688,36.7295,63,36.874,63c0.207,0,0.4141-0.0645,0.5879-0.1909c0.2939-0.2134,0.4492-0.5703,0.4043-0.9316     l-0.5615-4.5557l3.1348-3.3535c0.249-0.2661,0.333-0.646,0.2207-0.9922C40.5479,52.6304,40.2559,52.3726,39.8984,52.3032z      M35.5244,56.2979c-0.2021,0.2163-0.2979,0.5112-0.2617,0.8052l0.3975,3.2251l-2.9424-1.377c-0.2695-0.126-0.5781-0.126-0.8477,0     l-2.9453,1.377l0.3994-3.2246c0.0371-0.2939-0.0596-0.5894-0.2617-0.8057l-2.2187-2.3745l3.1924-0.6172     c0.291-0.0566,0.542-0.2388,0.6855-0.498l1.5723-2.8447l1.5723,2.8447c0.1436,0.2593,0.3945,0.4414,0.6855,0.498l3.1914,0.6172     L35.5244,56.2979z" />
          <path d="M62.2402,52.9761c-0.1123-0.3457-0.4043-0.6035-0.7607-0.6729l-4.5078-0.8721l-2.2217-4.019     c-0.1758-0.3184-0.5107-0.5161-0.875-0.5161S53.1758,47.0938,53,47.4121l-2.2227,4.019l-4.5078,0.8721     c-0.3564,0.0693-0.6484,0.3271-0.7607,0.6733s-0.0273,0.7261,0.2207,0.9917l3.1367,3.3535l-0.5645,4.5552     c-0.0449,0.3613,0.1104,0.7183,0.4043,0.9321c0.2939,0.2144,0.6826,0.25,1.0117,0.0967l4.1572-1.9448l4.1592,1.9448     C58.1689,62.9688,58.3135,63,58.458,63c0.208,0,0.4141-0.0645,0.5879-0.1909c0.2939-0.2139,0.4492-0.5708,0.4043-0.9321     l-0.5645-4.5552l3.1338-3.354C62.2686,53.7021,62.3525,53.3223,62.2402,52.9761z M57.1055,56.2979     c-0.2021,0.2163-0.2988,0.5117-0.2617,0.8057l0.3994,3.2246l-2.9443-1.377c-0.1348-0.063-0.2793-0.0942-0.4238-0.0942     s-0.2891,0.0313-0.4238,0.0942l-2.9424,1.3765l0.3994-3.2241c0.0371-0.2944-0.0596-0.5894-0.2617-0.8062l-2.2207-2.374     l3.1914-0.6172c0.29-0.0566,0.541-0.2388,0.6846-0.498l1.5732-2.8452l1.5723,2.8452c0.1436,0.2593,0.3945,0.4414,0.6846,0.498     l3.1924,0.6172L57.1055,56.2979z" />
        </g>
      </g>
    </g>
    <g id="_x30_8_email" />
    <g id="_x30_7_information" />
    <g id="_x30_6_phone_talking" />
    <g id="_x30_5_women_talking" />
    <g id="_x30_4_calling" />
    <g id="_x30_3_women" />
    <g id="_x30_2_writing" />
    <g id="_x30_1_chatting" />
  </svg>
);

export const PlusIcon = ({ className, width, height }: IconsProps) => (
  <svg
    fill="#000000"
    width={width || "24px"}
    height={height || "24px"}
    viewBox="0 0 24 24"
    id="plus"
    data-name="Line Color"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="primary"
      d="M5,12H19M12,5V19"
      style={{
        fill: "none",
        stroke: "rgb(0, 0, 0)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
      }}
    />
  </svg>
);
